import { getStore } from '~/mobx/AppStore';
import candidateApi from '~/clientApis/candidateApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';

const updateCandidatePhoto = async () => {
    // If there's a preview file, upload it first
    const candidateStore = getStore().candidateStore;
    const selectedCandidateEdit = candidateStore.selectedCandidateEdit;

    try {
        if (candidateStore.previewCandidatePhoto) {
            candidateStore.setIsUploadingCandidatePhoto(true);
            await candidateApi.uploadCandidatePhoto(selectedCandidateEdit.id, candidateStore.previewCandidatePhoto);
            candidateStore.setPreviewCandidatePhoto(null);
        }
    } catch {
        showMessageModal('error', 'Kunne ikke laste opp fil');
        return Promise.reject(new Error('Upload media failed'));
    } finally {
        candidateStore.setIsUploadingCandidatePhoto(false);
    }
};

export default updateCandidatePhoto;
